<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="ots-title">
      <p>考试批次：{{ planName }}</p>
      <p>场次：{{ sessionName }}</p>
      <p>考点：{{ placeName }}</p>
    </div>
    <div>
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="requestForm"
        @search="search"
      />
      <div class="mainCon">
        <ots-table-group
          :tableHeader="tableHeader"
          :tableData="tableData"
          :pagination="pagination"
          :batchOperBtn="batchOperBtn"
          @handleSelectionChange="bachOper"
          :tableOption="tableOption"
          @changeNum="changeNum"
          @changePage="changePage"
        ></ots-table-group>
        <!-- <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :tableOption="tableOption"
        @handleSelectionChange="bachOper"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
      >
      </ots-table-group-new> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  getTourTeacherAddListFn,
  addTourTeacherFn,
  delTourTeacherFn,
} from "@/http/modules/examSet/examBatch";
export default {
  data() {
    return {
      tableOption: {
        multiple: false,
      },
      batchOperBtn: [
      {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
        // {
        //   title: "批量添加",
        //   click: this.addTourTeacher,
        // },
      ],
      teacherId: [],
      placeName: "",
      selectList: [
        {
          title: "用户状态",
          type: "select",
          requestKey: "setFlag",
          label: "name",
          value: "id",
          data: [
            {
              name: "未添加",
              id: "0",
            },
            {
              name: "已添加",
              id: "1",
            },
          ],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "keyword",
          placeholder: "用户名/姓名",
        },
      ],
      tableHeader: [
        {
          title: "巡考员姓名",
          prop: "realName",
        },
        {
          title: "巡考员用户名",
          prop: "userName",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "用户状态",
          prop: "setFlagName",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "添加",
              click: this.addTor,
              disableFn: (val) =>
                val.row.setFlagName === "未添加" ? false : true,
            },
            {
              title: "删除",
              click: this.deleTor,
              disableFn: (val) =>
                val.row.setFlagName === "已添加" ? false : true,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      requestForm: {
        page: 1,
        size: 10,
        setFlag: "0",
        keyword: "",
        planId: this.$route.query.planId,
        sessionId: this.$route.query.sessionId,
        placeId: this.$route.query.placeId,
      },
      stuIds: [],
    };
  },
  watch: {
    "requestForm.setFlag": function () {
      this.getClassList();
      if(this.requestForm.setFlag == 1){
        this.batchOperBtn =   [
         {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
        // {
        //   title: "批量删除",
        //   click: this.deleteTourTeacher,
        // },
      ]
      }else{
        this.batchOperBtn =   [
         {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
        // {
        //   title: "批量添加",
        //   click: this.addTourTeacher,
        // },
      ]
      }
    },
  },
  methods: {
    search() {
      this.requestForm.page = 1;
      this.getClassList();
    },
    getClassList() {
      let params = {...this.requestForm};
      getTourTeacherAddListFn(params).then((data) => {
        this.tableData = data.data.records;
        this.pagination.total = data.data.total;
      });
    },
    changeNum(num) {
      this.requestForm.size = num;
      this.getClassList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getClassList(true);
    },
    addTor(row) {
      let params = {
        teacherIds: row.teacherId,
        planId: this.$route.query.planId,
        sessionId: this.$route.query.sessionId,
        placeId: this.$route.query.placeId,
      };
      addTourTeacherFn(params).then((res) => {
        if (res.code === 1) {
          this.$message.success("添加成功");
          this.getClassList();
        }
      });
    },
    deleTor(row) {
      let params = {
        teacherIds: row.teacherId,
      };
      this.$confirm("是否将该考点的巡考员删除？", "提示", {
        type: "warning",
      }).then(() => {
        delTourTeacherFn(params)
          .then((res) => {
            if (res.code === 1) {
              this.getClassList();
              this.$message.success("删除成功");
            }
          })
          .catch(() => {});
      });
    },
    search() {
      this.requestForm.page = 1;
      this.getClassList();
    },
    deleteTourTeacher() {
      if (this.stuIds.length < 1) {
        this.$message({
          message: "请选择要删除的数据",
          type: "warning",
        });
        return;
      }
      let params = {
        teacherIds: this.stuIds + "",
      };
      this.$confirm("确定要删除该考点下所选巡考教师吗", "提示", {
        type: "warning",
      }).then(() => {
        delTourTeacherFn(params).then((res) => {
          this.getClassList();
          this.$message.success("删除成功");
        });
      });
    },
    addTourTeacher() {
      if (this.stuIds.length < 1) {
        this.$message({
          message: "请选择要添加的数据",
          type: "warning",
        });
        return;
      }
      let params = {
        teacherIds: this.stuIds + "",
        planId: this.$route.query.planId,
        sessionId: this.$route.query.sessionId,
        placeId: this.$route.query.placeId,
      };
      addTourTeacherFn(params).then((res) => {
        this.$message.success("添加成功");
        this.getClassList();
      });
    },
    bachOper(val) {
      this.stuIds = [];
      let idList = [];
      val.forEach((item) => {
        idList.push(item.teacherId);
      });
      this.stuIds = idList;
    },
  },
  created() {
    this.placeName = this.$route.query.placeName;
    this.planName = this.$route.query.planName;
    this.sessionName = this.$route.query.sessionName;
    this.getClassList();
  },
};
</script>
<style lang="less" scoped>
.detailBox-l {
  width: 100%;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  float: left;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 24px;
    border-bottom: 1px solid #f1f2f5;
    h1 {
      color: #2d2f33;
      font-size: 20px;
    }
  }
}
.ots-title {
  margin-top:15px ;
  display: flex;
  justify-content: space-between;
  background: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom: 20px;
}
</style>